<header class="background-header classic-background"></header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
    <section class="container admin-dashboard-parent monitoring-container">
        <section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Monitoring'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
                <h1>Monitoring</h1>
			</div>
		</section>
    </section>
</section>